<template>
 <Head>
    <title>Edit Department | {{$page.props.appName}}</title>
    <meta name="description" :content="'Edit Department ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
      <form @submit.prevent="false">
       

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Department Name:</label>
            <input v-model="this.form.department_name" type="text" class="form-input" />
          </div>

          
        </div>
        <div class="w-full">
             <button class="bg-red-400 text-white font-bold p-2 ml-6 mt-3 float-left" @click="deletedata()">DELETE DEPARTMENT </button>
            <button type="submit" class="bg-black text-white font-bold p-2 mr-6 mt-3 float-right" :disabled="form.processing" @click="store()">EDIT DEPARTMENT </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  props : {
      'department' : Object,
      'id' : String
  },
  layout: Layout,
  components: { Link, Head, Pagination },
  data() {
    return {
      url: "",
      form: this.$inertia.form({
        department_name: this.department.department_name,
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/department/edit/" + this.id);
    },
    deletedata() {
        if(confirm("Are you sure you want to delete this department?")){
            this.$inertia.delete("/admin/department/edit/" + this.id)
        }
    }
  },
};
</script>
     